module.exports = __webpack_public_path__ + "img/renew_card.25f07ba5.png";